import $ from "jquery";
import BD_Component from "@bd-core/bd-component";
import compile from "@bd-utils/handlerbars-helper";
import QRCodeStyling from "qr-code-styling";
import jsQR from "jsqr";
import CONFIG from "@bd-core/config";
import GameLogic from "@bd-core/game-logic";
import bdjs from "@bd-core/bdjs";
import bdapi from "@bd-core/bd-api";

/**
 * QR Code page: scan codes and show "My Code" view.
 * Note: QR generation for the user's own code was moved to profile.js (card-profile flip side).
 * The generateQrData, formatTime, updateTimer, startTimer, and updateQrCode methods in this file
 * are UNUSED and kept for reference only.
 */
export class QrCodePage extends BD_Component {
    constructor() {
        super();

        this.id = "qr-code";
        this.template = "qr-code-template";

        this.elms = {
            qrCode: ".qr-code-page__qr-code",
            backButton: ".js-back-button",
            timerValue: "#qr-timer-value",
            tabMyCode: "#tab-my-code",
            tabScanCode: "#tab-scan-code",
            myCodeView: "#qr-view-my-code",
            scanCodeView: "#qr-view-scan-code",
            scannerElementId: "qr-scanner-reader",
            errorContainerId: "qr-scanner-error",
            scanOverviewPopup: "#scan-overview-popup",
            cardItem: ".card-item",
            cardItemDepartment: "#card-item-department",
            cardItemAvatar: "#card-item-avatar",
            cardItemName: "#card-item-name",
            cardItemRole: "#card-item-role",
            cardItemExperience: "#card-item-experience",
            cardItemExperienceQuestion:
                "#card-item-bizzare-experience-question",
            scanOverviewAddBtn: "#scan-overview-add",
            scanOverviewCancelBtn: "#scan-overview-cancel",
            scanOverviewCloseBtn: "#scan-overview-close",
            scanOverviewAlreadyCloseBtn: ".js-scan-overview-already-close",
            qrCodePageAvatar: "#qr-code-page-avatar",
            successCard: "#card-success-colleague",
            successCardFirstname: "#card-success-colleague-firstname",
            successCardLastname: "#card-success-colleague-lastname",
            successCardDepartment: "#card-success-colleague-dept",
            successCardRole: "#card-success-colleague-role",
            successCardAvatar: "#card-success-colleague-avatar",
            checkAnimationPopup: ".js-check-animation-popup",
            checkContinueBtn: ".js-check-animation-popup .js-continue",
            achievementAnimationPopup: ".js-achievement-animation-popup",
            achievementContinueBtn: ".js-achievement-animation-popup .js-continue",
            achievementImg: ".js-achievement-animation-popup .js-achievement-img",
            achievementTitle: ".js-achievement-animation-popup .js-achievement-title",
            achievementSubtitle: ".js-achievement-animation-popup .js-achievement-subtitle",
            achievementPoints: ".js-achievement-animation-popup .js-achievement-points",
            pointAnimationPopup: ".js-point-animation-popup",
            pointPoints: ".js-point-animation-popup .js-points",
            pointSeeProgressBtn: ".js-point-animation-popup .js-see-progress",
            pointCloseBtn: ".js-point-animation-popup .js-close",
            snackBar: ".js-snackbar",
        };
        this._events = this.getEvents();

        this.userId = 0;
        this.colleagueUserId = 0;
        this.colleagueQrToken = null;
        this.lastAddResult = null;
        this.achievementIndex = 0;

        // --- QR generation (UNUSED: moved to profile.js; kept for reference) ---
        this.qrCodeInstance = null;
        this.qrUpdateInterval = null;
        this.timerInterval = null;
        this.qrCodeMode = CONFIG.game?.qr_code_mode ?? "static";
        this.qrCodeExpiryMs = CONFIG.game?.qr_code_expiry_ms ?? null;
        this.timeRemaining = this.qrCodeExpiryMs ?? 0;

        this.video = null;
        this.canvas = null;
        this.canvasContext = null;
        this.videoStream = null;
        this.animationFrameId = null;
        this.isScanning = false;
    }

    getEvents() {
        const elms = this.elms;

        return [
            {
                event: "click",
                selector: elms.backButton,
                handler: this.goBack,
            },
            {
                event: "click",
                selector: elms.tabMyCode,
                handler: this.switchToMyCode,
            },
            {
                event: "click",
                selector: elms.tabScanCode,
                handler: this.switchToScanCode,
            },
            {
                event: "click",
                selector: elms.scanOverviewAddBtn,
                handler: this.handleAfterAddColleagueCard,
            },
            {
                event: "click",
                selector: elms.scanOverviewCancelBtn,
                handler: this.onScanOverviewCancel,
            },
            {
                event: "click",
                selector: elms.scanOverviewCloseBtn,
                handler: this.onScanOverviewClose,
            },
            {
                event: "click",
                selector: elms.scanOverviewAlreadyCloseBtn,
                handler: this.onScanOverviewAlreadyClose,
            },
            {
                event: "click",
                selector: elms.checkContinueBtn,
                handler: this.onCheckContinue,
            },
            {
                event: "click",
                selector: elms.achievementContinueBtn,
                handler: this.onAchievementContinue,
            },
            {
                event: "click",
                selector: elms.pointSeeProgressBtn,
                handler: this.onPointSeeProgress,
            },
            {
                event: "click",
                selector: elms.pointCloseBtn,
                handler: this.onPointClose,
            },
        ];
    }

    beforeInit() {
        this.render();
        this.setGameState();
    }

    afterInit() {
        this._visibilityHandler = this.onVisibilityChange.bind(this);
        document.addEventListener("visibilitychange", this._visibilityHandler);
    }

    /**
     * Stop scanning when tab is hidden; resume when visible if scan view is active.
     */
    onVisibilityChange() {
        if (document.hidden) {
            this.stopScanning();
        } else if ($(this.elms.scanCodeView).hasClass("active")) {
            this.startScanning();
        }
    }

    render() {
        const data = this._data;
        this.userId = data.user_profile.user_id;

        const htmlTemplate = $("#" + this.template).html();
        const html = compile(htmlTemplate, data);
        $(".app").html(html);

        const params = new URLSearchParams(window.location.search);
        const hasUserTokenParams =
            params.get("user_id") &&
            params.get("token") &&
            !params.get("trade_id");
        if (!hasUserTokenParams) {
            this.startScanning();
        }
    }

    goBack() {
        GameLogic.goToPage("profile");
        window.navigation?.setActiveNavItem("profile");
    }

    switchToMyCode() {
        const elms = this.elms;

        this.stopScanning();

        $(elms.tabScanCode).removeClass("active");
        $(elms.tabMyCode).addClass("active");
        $(elms.myCodeView).addClass("active");
        $(elms.scanCodeView).removeClass("active");
    }

    switchToScanCode() {
        const elms = this.elms;

        $(elms.tabMyCode).removeClass("active");
        $(elms.tabScanCode).addClass("active");
        $(elms.myCodeView).removeClass("active");
        $(elms.scanCodeView).addClass("active");

        this.startScanning();
    }

    async startScanning() {
        const readerElement = document.getElementById(
            this.elms.scannerElementId,
        );

        if (!readerElement) {
            console.warn("QR Scanner element not found");
            return;
        }

        if (this.isScanning) {
            return;
        }

        await this.stopScanning();

        try {
            this.video = document.createElement("video");
            this.video.setAttribute("playsinline", "");
            this.video.setAttribute("muted", "");
            this.video.setAttribute("autoplay", "");
            this.video.playsInline = true;
            this.video.muted = true;

            this.canvas = document.createElement("canvas");
            this.canvasContext = this.canvas.getContext("2d", {
                willReadFrequently: true,
            });

            const existingVideo = readerElement.querySelector("video");
            const existingCanvas = readerElement.querySelector("canvas");

            if (existingVideo) {
                existingVideo.remove();
            }
            if (existingCanvas) {
                existingCanvas.remove();
            }

            readerElement.appendChild(this.video);
            readerElement.appendChild(this.canvas);

            void readerElement.offsetHeight;

            const constraints = {
                video: {
                    facingMode: "environment",
                    width: { ideal: 1280 },
                    height: { ideal: 720 },
                },
            };

            if (
                !navigator.mediaDevices ||
                !navigator.mediaDevices.getUserMedia
            ) {
                throw new Error(
                    "Camera access is not available in this browser.",
                );
            }

            if (!window.isSecureContext && location.protocol !== "https:") {
                throw new Error(
                    "Camera access requires a secure connection (HTTPS).",
                );
            }

            this.videoStream =
                await navigator.mediaDevices.getUserMedia(constraints);

            this.video.srcObject = this.videoStream;

            try {
                await this.video.play();
            } catch (playError) {
                console.warn(
                    "Video play error (may be expected on iOS):",
                    playError,
                );
            }

            this.isScanning = true;
            this.showScannerUI();
            this.scanTick();
        } catch (err) {
            console.error("Failed to start QR scanner:", err);
            this.showCameraError(err);
            this.isScanning = false;
        }
    }

    async stopScanning() {
        if (!this.isScanning) {
            return;
        }

        try {
            if (this.animationFrameId) {
                cancelAnimationFrame(this.animationFrameId);
                this.animationFrameId = null;
            }

            if (this.videoStream) {
                this.videoStream.getTracks().forEach((track) => {
                    track.stop();
                });
                this.videoStream = null;
            }

            if (this.video) {
                this.video.srcObject = null;
                this.video = null;
            }

            this.canvas = null;
            this.canvasContext = null;

            this.isScanning = false;
            this.hideScannerUI();
        } catch (err) {
            console.error("Failed to stop QR scanner:", err);
        }
    }

    /**
     * Continuously scan video frames for QR codes
     */
    scanTick() {
        if (
            !this.isScanning ||
            !this.video ||
            !this.canvas ||
            !this.canvasContext
        ) {
            return;
        }

        if (this.video.readyState === this.video.HAVE_ENOUGH_DATA) {
            const videoIntrinsicWidth = this.video.videoWidth;
            const videoIntrinsicHeight = this.video.videoHeight;
            const videoDisplayWidth = this.video.offsetWidth;
            const videoDisplayHeight = this.video.offsetHeight;

            this.canvas.width = videoDisplayWidth;
            this.canvas.height = videoDisplayHeight;

            this.canvasContext.drawImage(
                this.video,
                0,
                0,
                videoIntrinsicWidth,
                videoIntrinsicHeight,
                0,
                0,
                videoDisplayWidth,
                videoDisplayHeight,
            );

            const imageData = this.canvasContext.getImageData(
                0,
                0,
                this.canvas.width,
                this.canvas.height,
            );

            const code = jsQR(
                imageData.data,
                imageData.width,
                imageData.height,
                {
                    inversionAttempts: "dontInvert",
                },
            );

            if (code) {
                this.handleScanSuccess(code.data);
                return;
            }
        }

        this.animationFrameId = requestAnimationFrame(() => this.scanTick());
    }

    async handleScanSuccess(decodedText) {
        await this.stopScanning();
        const validationResult = await this.validateScan(decodedText);

        if (!validationResult.success) {
            setTimeout(() => {
                alert(validationResult.data || "The QR code is invalid.");
                this.startScanning();
            }, 100);
            return;
        }

        if (validationResult.data.isTrade) {
            const params = new URLSearchParams(window.location.search);
            params.set("trade_id", validationResult.data.tradeId);
            params.set("user_id", validationResult.data.userId);
            params.set("token", validationResult.data.token);
            const newUrl =
                window.location.pathname +
                "?" +
                params.toString() +
                window.location.hash;
            window.history.replaceState({}, "", newUrl);
            GameLogic.goToPage("collection");

            window.navigation?.setActiveNavItem("collections");
            return;
        }

        if (validationResult.data.isLocationMission) {
            const params = new URLSearchParams(window.location.search);
            params.set("location_mission_id", validationResult.data.locationMissionId);
            const newUrl =
                window.location.pathname +
                "?" +
                params.toString() +
                window.location.hash;
            window.history.replaceState({}, "", newUrl);
            GameLogic.goToPage("mission");
            window.navigation?.setActiveNavItem("missions");
            return;
        }

        this.showScanSuccess(validationResult.data);
    }

    async validateScan(decodedText) {
        try {
            const url = new URL(decodedText, window.location.origin);
            const timestamp = Date.now();

            const userId = url.searchParams.get("user_id");
            const tradeId = url.searchParams.get("trade_id");
            const token = url.searchParams.get("token");
            const locationMissionId = Number(url.searchParams.get(
                "location_mission_id",
            ));

            // Location mission QR codes may have no token
            if (locationMissionId) {
                return this.validateScanWithLocationMissionId({
                    locationMissionId,
                });
            }

            if ((!userId && !tradeId) || !token) {
                const errorMessage = "QR code invalid.";
                console.warn(errorMessage);
                return {
                    success: false,
                    data: errorMessage,
                };
            }

            if (userId && !tradeId) {
                return this.validateScanWithUserId({
                    userId,
                    token,
                    timestamp,
                });
            }

            if (tradeId) {
                return this.validateScanWithTradeId({
                    userId,
                    tradeId,
                    token,
                    timestamp,
                });
            }

            return {
                success: false,
                data: "QR code invalid.",
            };
        } catch (e) {
            const errorMessage =
                "Invalid QR code format. Could not extract parameters.";
            console.warn(errorMessage, e);
            return {
                success: false,
                data: errorMessage,
            };
        }
    }

    /**
     * Validates a QR code that encodes user_id (e.g. user profile / identity).
     */
    async validateScanWithUserId({ userId, token }) {
        const formData = new FormData();
        formData.append("user_id", userId);
        formData.append("token", token);

        const [response] = await bdjs.goAsync(
            bdapi.post("game/validate-qr-code", formData),
        );

        if (response?.data?.success) {
            return {
                success: true,
                data: {
                    ...response.data.data,
                    qr_token: token,
                },
            };
        }

        return {
            success: false,
            data: "QR code validation failed.",
        };
    }

    /**
     * Validates a QR code that encodes trade_id (e.g. trade session).
     */
    async validateScanWithTradeId({ userId, tradeId, token }) {
        return {
            success: true,
            data: {
                isTrade: true,
                userId,
                tradeId,
                token,
            },
        };
    }

    validateScanWithLocationMissionId({ locationMissionId }) {
        return {
            success: true,
            data: {
                isLocationMission: true,
                locationMissionId: Number(locationMissionId),
            },
        };
    }

    showScannerUI() {
        const scannerContainer = document.getElementById(
            this.elms.scannerElementId,
        );

        if (scannerContainer) {
            scannerContainer.classList.add("active");
        }
    }

    hideScannerUI() {
        const scannerContainer = document.getElementById(
            this.elms.scannerElementId,
        );

        if (scannerContainer) {
            scannerContainer.classList.remove("active");
        }
    }

    showCameraError(error) {
        const errorContainer = document.getElementById(
            this.elms.errorContainerId,
        );

        if (errorContainer) {
            let message = "Unable to access camera.";

            if (error.name === "NotAllowedError") {
                const isIOS =
                    /iPad|iPhone|iPod/.test(navigator.userAgent) ||
                    (navigator.platform === "MacIntel" &&
                        navigator.maxTouchPoints > 1);

                if (isIOS) {
                    message =
                        "Camera access denied. Please check Safari settings and ensure the site has camera permissions. You may need to refresh the page after granting permissions.";
                } else {
                    message =
                        "Camera access denied. Please allow camera permissions in your browser settings.";
                }
            } else if (error.name === "NotFoundError") {
                message = "No camera found on this device.";
            } else if (error.name === "NotReadableError") {
                message = "Camera is already in use by another application.";
            } else if (error.name === "SecurityError") {
                message = "Camera access requires a secure connection (HTTPS).";
            }

            errorContainer.textContent = message;
            errorContainer.classList.add("active");
        }

        document.dispatchEvent(
            new CustomEvent("qr:camera-error", {
                detail: { error },
            }),
        );
    }

    showScanSuccess(colleagueCard) {
        const elms = this.elms;

        this.lastAddResult = null;
        this.achievementIndex = 0;
        this.colleagueUserId = colleagueCard.colleague_card.colleague_id;
        this.colleagueQrToken = colleagueCard.qr_token ?? null;
        const userProfile = colleagueCard.colleague_card;
        const isInCollection = colleagueCard.is_in_collection;
        const department = userProfile.department;
        const bizzareExperienceQuestion = CONFIG.game.pages.find(
            (page) => page.id === "profile",
        ).data.text_settings.bizzare_experience_question;

        $(elms.cardItem).addClass(`card-item--${userProfile.rarity_level}`);
        $(elms.cardItemDepartment).text(userProfile.department.title);
        $(elms.cardItemAvatar).attr("src", userProfile.avatar);
        $(elms.cardItemName).text(
            userProfile.first_name + " " + userProfile.last_name,
        );
        $(elms.cardItemRole).text(userProfile.role);
        $(elms.cardItemExperience).text(userProfile.bizzare_experience);
        $(elms.cardItemExperienceQuestion).text(bizzareExperienceQuestion);

        $(elms.scanOverviewPopup).addClass("active");
        if (isInCollection) {
            $(elms.scanOverviewPopup).addClass("has-collected");
        }

        $(elms.successCard).addClass(
            `card-success--colleague--${userProfile.rarity_level}`,
        );
        $(elms.successCardFirstname).text(userProfile.first_name);
        $(elms.successCardLastname).text(userProfile.last_name);
        $(elms.successCardDepartment).text(department.title);
        $(elms.successCardRole).text(userProfile.role);
        $(elms.successCardAvatar).attr("src", userProfile.avatar);

        // setTimeout(() => {
        this.onScanOverviewAdd();
        // }, 3000);
    }

    resetScanSuccess() {
        const elms = this.elms;
        $(elms.scanOverviewPopup).removeClass("active has-collected");
        this.colleagueQrToken = null;

        $(elms.cardItem).removeClass(function() {
            return $(this).attr("class").split(" ").filter(className => className.match(/(^|\s)card-item--\S+/g)).join(" ");
        });
        $(elms.cardItemDepartment).text("");
        $(elms.cardItemAvatar).attr("src", "");
        $(elms.cardItemName).text("");
        $(elms.cardItemRole).text("");
        $(elms.cardItemExperience).text("");
        // $(elms.cardItemExperienceQuestion).text("");

        $(elms.successCard).removeClass(function() {
            return $(this).attr("class").split(" ").filter(className => className.match(/(^|\s)card-success--colleague--\S+/g)).join(" ");
        });
        $(elms.successCardFirstname).text("");
        $(elms.successCardLastname).text("");
        $(elms.successCardDepartment).text("");
        $(elms.successCardRole).text("");
        $(elms.successCardAvatar).attr("src", "");

        $(elms.checkAnimationPopup).removeClass("active");
        $(elms.achievementAnimationPopup).removeClass("active");
        $(elms.pointAnimationPopup).removeClass("active");
    }

    /**
     * Generate QR code data.
     * @deprecated UNUSED – QR generation moved to profile.js; code kept for reference.
     * @returns {string|null} QR code data URL
     */
    generateQrData() {
        return null;
    }

    /**
     * Format time in milliseconds to MM:SS format.
     * @deprecated UNUSED – QR generation moved to profile.js; code kept for reference.
     * @param {number} ms - Time in milliseconds
     * @returns {string} Formatted time string (MM:SS)
     */
    formatTime(ms) {
        const totalSeconds = Math.floor(ms / 1000);
        const minutes = Math.floor(totalSeconds / 60);
        const seconds = totalSeconds % 60;
        return `${minutes}:${seconds.toString().padStart(2, "0")}`;
    }

    /**
     * Update the timer display.
     * @deprecated UNUSED – QR generation moved to profile.js; code kept for reference.
     */
    updateTimer() {
        const $timerValue = $(this.elms.timerValue);
        if ($timerValue.length) {
            $timerValue.text(this.formatTime(this.timeRemaining));
        }

        const intervalMs = this.qrCodeExpiryMs ?? CONFIG.game?.qr_code_expiry_ms ?? 5 * 60 * 1000;
        if (this.timeRemaining <= 0) {
            this.timeRemaining = intervalMs;
        } else {
            this.timeRemaining -= 1000;
        }
    }

    /**
     * Start the timer countdown.
     * @deprecated UNUSED – QR generation moved to profile.js; code kept for reference.
     */
    startTimer() {
        if (this.timerInterval) {
            clearInterval(this.timerInterval);
        }

        this.timeRemaining = this.qrCodeExpiryMs ?? CONFIG.game?.qr_code_expiry_ms ?? 5 * 60 * 1000;
        this.updateTimer();

        this.timerInterval = setInterval(() => {
            this.updateTimer();
        }, 1000);
    }

    /**
     * Update the QR code with new data.
     * @deprecated UNUSED – QR generation moved to profile.js; code kept for reference.
     */
    updateQrCode() {
        const $qrCodeElement = $(this.elms.qrCode);
        const qrCodeElement = $qrCodeElement[0];

        if (!qrCodeElement) {
            console.error("QR code element not found:", this.elms.qrCode);
            return;
        }

        const qrData = this.generateQrData();
        if (!qrData) return;

        qrCodeElement.innerHTML = "";

        const calculateQrSize = () => {
            const containerWidth = $qrCodeElement.width();
            const availableWidth = containerWidth || 200;
            const qrSize = Math.max(200, Math.min(availableWidth, 200));
            return qrSize;
        };

        let qrSize = calculateQrSize();
        if (qrSize === 200 && !$qrCodeElement.width()) {
            qrSize = 200;
        }

        this.qrCodeInstance = new QRCodeStyling({
            width: qrSize,
            height: qrSize,
            type: "svg",
            data: qrData,
            margin: 10,
            image: CONFIG.game.qrLogoURL,
            dotsOptions: {
                color: "#000000",
                type: "square",
                roundSize: false,
            },
            cornersSquareOptions: {
                color: "#000000",
                type: "square",
            },
            cornersDotOptions: {
                color: "#000000",
                type: "square",
            },
            backgroundOptions: {
                color: "#ffffff",
            },
        });

        this.qrCodeInstance.append(qrCodeElement);

        this.startTimer();
    }

    async onScanOverviewAdd() {
        if (!this.colleagueUserId || !this.colleagueQrToken) {
            return;
        }

        const formData = new FormData();
        formData.append("user_id", this.colleagueUserId.toString());
        formData.append("token", this.colleagueQrToken);

        const [response] = await bdjs.goAsync(
            bdapi.post("game/add-colleague-card", formData),
        );

        if (response?.data?.success) {
            const data = response.data.data;
            this.lastAddResult = {
                card_point: data.card_point,
                achievements: Array.isArray(data.achievements)
                    ? data.achievements
                    : [],
            };
        } else {
            alert(response?.data?.data || "Failed to add colleague card.");
        }
    }

    handleAfterAddColleagueCard() {
        // $(this.elms.scanOverviewPopup).addClass("is-collected");
        $(this.elms.checkAnimationPopup).addClass("active");

        setTimeout(() => {
            this.onCheckContinue();
        }, 3000);
    }

    onScanOverviewCancel() {
        const elms = this.elms;
        $(elms.scanOverviewPopup).removeClass("active has-collected");

        $(elms.tabMyCode).removeClass("active");
        $(elms.tabScanCode).addClass("active");
        $(elms.myCodeView).removeClass("active");
        $(elms.scanCodeView).addClass("active");
        this.startScanning();
    }

    onScanOverviewClose() {
        const elms = this.elms;
        $(elms.checkAnimationPopup).addClass("active");
    }

    /**
     * Close "already collected" popup and return to scan view (same as cancel).
     */
    onScanOverviewAlreadyClose() {
        this.onScanOverviewCancel();
    }

    /**
     * Shared cleanup: close scan overview and all three popups, then resume scanning.
     */
    closeScanSuccessPopupsAndResume() {
        const elms = this.elms;
        $(elms.scanOverviewPopup).removeClass(
            "active has-collected is-collected",
        );
        this.lastAddResult = null;
        this.achievementIndex = 0;
        $(elms.tabMyCode).removeClass("active");
        $(elms.tabScanCode).addClass("active");
        $(elms.myCodeView).removeClass("active");
        $(elms.scanCodeView).addClass("active");
        $(elms.checkAnimationPopup).removeClass("active");
        $(elms.achievementAnimationPopup).removeClass("active");
        $(elms.pointAnimationPopup).removeClass("active");
        this.startScanning();
    }

    /**
     * Populate achievement popup DOM with the current achievementIndex (no visibility change).
     */
    populateAchievementContent() {
        const elms = this.elms;
        const achievements = this.lastAddResult?.achievements;
        const achievementItem = achievements?.[this.achievementIndex];
        if (!achievementItem) {
            return;
        }
        const firstStep = achievementItem.steps?.[0];
        $(elms.achievementTitle).text(
            (firstStep?.title ?? achievementItem.title) || "",
        );
        const achievementSubtitle =
            this._data?.text_settings?.text_achievement_unlocked ??
            "Prestatie behaald!";
        $(elms.achievementSubtitle).text(achievementSubtitle);
        if (firstStep?.icon) {
            $(elms.achievementImg).attr("src", firstStep.icon);
        }
        $(elms.achievementPoints).text(`+${firstStep.points}`);
    }

    /**
     * Populate and show the achievement popup for the current achievementIndex.
     */
    showAchievementPopup() {
        this.populateAchievementContent();
        $(this.elms.achievementAnimationPopup).addClass("active");
    }

    /**
     * Populate and show the point popup.
     */
    showPointPopup() {
        const elms = this.elms;
        const points = this.lastAddResult?.card_point;
        $(elms.pointPoints).text(points != null ? String(points) : "0");
        $(elms.pointAnimationPopup).addClass("active");
    }

    /** Duration (ms) for content fade when switching to next achievement. */
    static ACHIEVEMENT_SWITCH_DURATION_MS = 250;
    /** Duration (ms) for crossfade between popups. Must match popup CSS transition. */
    static POPUP_TRANSITION_MS = 300;

    onCheckContinue() {
        if (this.lastAddResult?.achievements?.length) {
            this.achievementIndex = 0;
            this.showAchievementPopup();
            return;
        }
        if (this.lastAddResult?.card_point != null) {
            this.showPointPopup();
            return;
        }

        setTimeout(() => {
            this.closeScanSuccessPopupsAndResume();
            this.resetScanSuccess();
            this.colleagueUserId = 0;
            this.colleagueQrToken = null;
        }, QrCodePage.POPUP_TRANSITION_MS);
    }

    onAchievementContinue() {
        const elms = this.elms;
        const $achievement = $(elms.achievementAnimationPopup);
        this.achievementIndex++;
        const achievements = this.lastAddResult?.achievements ?? [];

        if (this.achievementIndex < achievements.length) {
            $achievement.addClass("achievement-animation-popup--switching");
            setTimeout(() => {
                this.populateAchievementContent();
                $achievement.removeClass("achievement-animation-popup--switching");
            }, QrCodePage.ACHIEVEMENT_SWITCH_DURATION_MS);
            return;
        }
        $achievement.addClass("achievement-animation-popup--leaving");
        if (this.lastAddResult?.card_point != null) {
            this.showPointPopup();
            setTimeout(() => {
                $achievement.removeClass("active achievement-animation-popup--leaving");
            }, QrCodePage.POPUP_TRANSITION_MS);
            return;
        }
        setTimeout(() => {
            $achievement.removeClass("active achievement-animation-popup--leaving");
            this.closeScanSuccessPopupsAndResume();
        }, QrCodePage.POPUP_TRANSITION_MS);
    }

    onPointSeeProgress() {
        GameLogic.goToPage("collection");
        window.navigation?.setActiveNavItem("collections");
    }

    onPointClose() {
        this.closeScanSuccessPopupsAndResume();
    }

    setGameState() {
        this.checkIfHasParams();
        // QR generation no longer used here – moved to profile.js (card-profile-qr-code)

        $(this.elms.myCodeView).toggleClass(
            "is-no-profile",
            !CONFIG.game.isProfileCreated,
        );

        $(this.elms.qrCodePageAvatar).attr(
            "src",
            this._data.user_profile.avatar,
        );
    }

    async checkIfHasParams() {
        const searchParams = new URLSearchParams(window.location.search);
        const userIdParam = searchParams.get("user_id");
        const tokenParam = searchParams.get("token");
        const tradeIdParam = searchParams.get("trade_id");

        if (userIdParam && tokenParam && !tradeIdParam) {
            const validationResult = await this.validateScan(
                window.location.href,
            );

            if (!validationResult.success) {
                setTimeout(() => {
                    alert(validationResult.data || "The QR code is invalid.");
                }, 100);
                return;
            }

            await this.stopScanning();
            this.showScanSuccess(validationResult.data);
        }

        const url = new URL(window.location.href);
        const paramsToRemove = ["user_id", "token", "trade_id"];
        paramsToRemove.forEach((param) => url.searchParams.delete(param));
        if (window.location.href !== url.toString()) {
            window.history.replaceState({}, document.title, url.toString());
        }
    }

    beforeDestroy() {
        if (this._visibilityHandler) {
            document.removeEventListener(
                "visibilitychange",
                this._visibilityHandler,
            );
            this._visibilityHandler = null;
        }
        if (this.qrUpdateInterval) {
            clearInterval(this.qrUpdateInterval);
            this.qrUpdateInterval = null;
        }
        if (this.timerInterval) {
            clearInterval(this.timerInterval);
            this.timerInterval = null;
        }
        if (this.isScanning) {
            this.stopScanning();
        }
    }
}
